import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import userTransformer from './transformers/user.transformer'

eventBus.$on(eventDefinitions.FORM.SUBMIT, formData => {
  if (!formData) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'form_submit',
    form_id: formData.form_id,
    form_user_properties: formData.user,
  })
})
